module.exports = require("babel-runtime/helpers/createClass");